module.exports = __webpack_public_path__ + "img/opening-process.421ab0ee.png";